import { gql } from "@grandvisionhq/graphql";
const StoreOffersFragment = gql`
  fragment StoreOffers on Store {
    offers {
      title
      description
      url
      imageUrl
    }
  }
`;
export {
  StoreOffersFragment as default
};
//# sourceMappingURL=store-offers.js.map
